// List of college majors from FiveThirtyEight dataset (truncated for brevity)
export const COLLEGE_MAJORS: string[] =[
  'ACCOUNTING',
  'ACTUARIAL SCIENCE',
  'AEROSPACE ENGINEERING',
  'AGRICULTURAL ECONOMICS',
  'AGRICULTURE PRODUCTION AND MANAGEMENT',
  'ANIMAL SCIENCES',
  'ARCHITECTURAL ENGINEERING',
  'ARCHITECTURE',
  'AREA ETHNIC AND CIVILIZATION STUDIES',
  'BIOCHEMICAL SCIENCES',
  'BOTANY',
  'BUSINESS ECONOMICS',
  'BUSINESS MANAGEMENT AND ADMINISTRATION',
  'CHEMICAL ENGINEERING',
  'CIVIL ENGINEERING',
  'COGNITIVE SCIENCE AND BIOPSYCHOLOGY',
  'COMMUNICATION DISORDERS SCIENCES AND SERVICES',
  'COMMUNICATIONS',
  'COMPUTER ENGINEERING',
  'COMPUTER PROGRAMMING AND DATA PROCESSING',
  'COMPUTER SCIENCE',
  'EDUCATIONAL ADMINISTRATION AND SUPERVISION',
  'ELECTRICAL ENGINEERING',
  'ENGINEERING GENERAL',
  'ENGINEERING MECHANICS PHYSICS AND SCIENCE',
  'ENVIRONMENTAL ENGINEERING',
  'FINANCE',
  'FLUID MECHANICS AND HYDRAULICS',
  'FOOD SCIENCE',
  'FORESTRY',
  'GENERAL AGRICULTURE',
  'GENERAL BIOLOGY',
  'GENERAL BUSINESS',
  'GENERAL COMPUTER AND INFORMATION SCIENCES',
  'GENERAL EDUCATION',
  'GENERAL ENGINEERING',
  'GEOLOGICAL AND GEOPHYSICAL ENGINEERING',
  'HOSPITALITY MANAGEMENT',
  'HUMAN RESOURCES AND PERSONNEL MANAGEMENT',
  'INDUSTRIAL AND MANUFACTURING ENGINEERING',
  'INFORMATION SCIENCES',
  'INTERNATIONAL BUSINESS',
  'JOURNALISM',
  'LANGUAGE AND LINGUISTICS',
  'MARKETING AND MARKETING RESEARCH',
  'MASS MEDIA',
  'MATERIALS ENGINEERING AND MATERIALS SCIENCE',
  'MECHANICAL ENGINEERING',
  'METALLURGICAL ENGINEERING',
  'MINING AND MINERAL ENGINEERING',
  'MIS AND COMPUTER SYSTEMS',
  'MISCELLANEOUS AGRICULTURE',
  'MISCELLANEOUS BIOLOGY',
  'MISCELLANEOUS ENGINEERING',
  'MOLECULAR BIOLOGY',
  'NATURAL RESOURCES AND CONSERVATION',
  'NATURAL RESOURCES MANAGEMENT',
  'NAVAL ARCHITECTURE AND MARINE ENGINEERING',
  'NUCLEAR ENGINEERING',
  'OPERATIONS LOGISTICS AND E-COMMERCE',
  'OTHER AGRICULTURE',
  'OTHER BUSINESS',
  'PETROLEUM ENGINEERING',
  'PHARMACOLOGY',
  'PHYSIOLOGY',
  'PLANT SCIENCE AND AGRONOMY',
  'SCHOOL STUDENT COUNSELING',
  'SOCIAL SCIENCE',
  'ZOOLOGY'
];